<template lang="pug">
.v-feedbacks-media.feedbacks-media(v-if="medias")
	.feedbacks-media__container
		.feedbacks-media__wrapper
			button.feedbacks-media__arrow.feedbacks-media__arrow--prev(type="button" ref="media-prev" aria-label="Предыдущий слайд")
				v-svg-icon.feedbacks-media__arrow-icon(icon="slide-left")
				v-svg-icon.feedbacks-media__arrow-bg(icon="slide-left-bg")
			button.feedbacks-media__arrow.feedbacks-media__arrow--next(type="button" ref="media-next" aria-label="Следующий слайд")
				v-svg-icon.feedbacks-media__arrow-icon(icon="slide-right")
				v-svg-icon.feedbacks-media__arrow-bg(icon="slide-right-bg")
			v-swiper-slider.feedbacks-media__slider(:options="options"
					:navigation="navigation"
					@swiper="onSwiper")
				swiper-slide(v-if="medias.items && medias.items.length"
						v-for="(media, mediaIndex) in medias.items"
						:key="mediaIndex")
					.feedbacks-media__media-wrapper
						.feedbacks-media__media-card
							.feedbacks-media__media-top
								img.feedbacks-media__media-logo(:src="media.image" alt="" loading="lazy")
								.feedbacks-media__media-rating-name
									v-rating.feedbacks-media__media-rating(:field.value="media.grade")
									.feedbacks-media__media-name {{media.name}}
							.feedbacks-media__media-bottom
								.feedbacks-media__media-bottom-text.scrollbar.scrollbar--gray(@mouseenter="blockScroll(mediaIndex)"
										@mouseleave="unblockScroll"
										:ref="`scrollContainer-${mediaIndex}`")
									| {{media.text}}
								a.feedbacks-media__media-link(
										:href="media.link"
										target="_blank")
									| {{media.btnText}}
</template>

<script>
import scrollLock from 'scroll-lock';
import sourceMixin from "../components/mixins/v-mixin-source.vue";
import breakpoints from "../scripts/breakpoints.js"
import {SwiperSlide} from "swiper/vue";
import isMobMixin from "../components/mixins/v-mixin-is-mob.vue";
export default {
	mixins: [
		sourceMixin,
		isMobMixin,
	],

	components: {
		SwiperSlide,
		scrollLock
	},

	data() {
		return {
			medias: null,
			scrollContainer: null,
			options: {
				slidesPerView: 'auto',
				breakpointsBase: 'container',
				breakpoints: {
					[breakpoints['md-mid']]: {
						spaceBetween: 14,
					},
					[breakpoints['4xs-min']]: {
						spaceBetween: 6,
					},
				},
			},
			allowTouchMove: true,
			pagination: {
				clickable: false,
			},
			navigation: false
		};
	},

	methods: {
		onSwiper() {
			this.navigation = {
				prevEl: this.$refs["media-prev"],
				nextEl: this.$refs["media-next"],
			};
		},

		blockScroll(index) {
			if (this.isSm) return;
			this.scrollContainer = this.$refs[`scrollContainer-${index}`][0];
			if (this.scrollContainer && (this.scrollContainer.scrollHeight > this.scrollContainer.clientHeight)) {
				if (document.body.classList.contains('state--header-fixed')) {
					const headerWrap = document.querySelector('.page-header-wrap');
					if (headerWrap) {
						headerWrap.classList.add('page-header-wrap--padding');
					}
				}
				scrollLock.disablePageScroll(this.scrollContainer);
			}
		},

		unblockScroll() {
			if (this.scrollContainer) {
				scrollLock.enablePageScroll(this.scrollContainer);
				const headerWrap = document.querySelector('.page-header-wrap');
				if (headerWrap && headerWrap.classList.contains('page-header-wrap--padding')) {
					headerWrap.classList.remove('page-header-wrap--padding')
				}
				this.scrollContainer = null;
			}
		},

		dataSet(data) {
			this.medias = data;
		}
	}
};
</script>